import React from 'react';
import clsx from 'clsx';
import { Typography } from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';

const MobileSlide = ({ imageUrl, header, text, imageTitle, index }) => {
  const highCnt = `${header}${text}`.length > 280;
  return (
    <div
      className={clsx(styles.mobileSlide, styles[`index${index}`], {
        [styles.highCnt]: highCnt
      })}
    >
      <div className={styles.textContainer}>
        <Typography Component="h3" className={styles.header}>
          {header}
        </Typography>
        <Typography className={styles.description}>{text}</Typography>
      </div>

      <div className={styles.slideImage}>
        <img src={imageUrl.desktop} alt="" title={imageTitle} />
      </div>
    </div>
  );
};

export default React.memo(MobileSlide);
